
export default {
  props: {
    membro: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      menu: [
        {
          text: 'Home',
          disabled: !1,
          to: '/'
        },
        {
          text: 'Nossa Equipe',
          disabled: !0,
          to: '/equipe'
        }
      ],
      title: 'Conheça nossa equipe de profissionais'
    }
  },
  computed: {
    site() {
      return site
    },
    height() {
      let size = 150,
        { xs, sm, mdAndUp } = this.$vuetify.breakpoint
      if (xs) size = 150
      else if (sm) size = 170
      else if (mdAndUp) size = 250
      return size
    }
  },
  created() {
    this.url = window.location.href
    if (this.membro) {
      this.title = this.membro
      this.menu[1].disabled = !1
      this.menu.push({
        text: this.membro,
        disabled: !0,
        to: '/equipe'
      })
    }
  }
}
